/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBillFileSearchResult } from './APIBillFileSearchResult';
import {
    APIBillFileSearchResultFromJSON,
    APIBillFileSearchResultFromJSONTyped,
    APIBillFileSearchResultToJSON,
} from './APIBillFileSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIBillFileSearchResponse
 */
export interface APIBillFileSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIBillFileSearchResult>}
     * @memberof APIBillFileSearchResponse
     */
    results: Array<APIBillFileSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIBillFileSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIBillFileSearchResponse interface.
 */
export function instanceOfAPIBillFileSearchResponse(value: object): value is APIBillFileSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIBillFileSearchResponseFromJSON(json: any): APIBillFileSearchResponse {
    return APIBillFileSearchResponseFromJSONTyped(json, false);
}

export function APIBillFileSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillFileSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIBillFileSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIBillFileSearchResponseToJSON(value?: APIBillFileSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIBillFileSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

